// This file was generated by lezer-generator. You probably shouldn't edit it.
export const Number = 1,
  Duration = 2,
  String = 3,
  IncompleteString = 4,
  ExistsOperator = 5,
  LogicalOperator = 6,
  InclusionOperator = 7,
  PositionOperator = 8,
  InvalidPositionOperator = 9,
  Filter = 10,
  FilterGroup = 11,
  OpeningBracket = 12,
  FilterStatement = 13,
  FilterKey = 14,
  Identifier = 15,
  InvalidIdentifier = 16,
  Variable = 17,
  ComparisonOperator = 18,
  InvalidComparisonOperator = 19,
  FilterSimpleValue = 20,
  Boolean = 21,
  FilterIncludesValue = 22,
  List = 23,
  ClosingBracket = 24,
  ListValue = 25,
  InvalidInclusionValue = 26;
